export function checkMinViewport(width) {
  return window.matchMedia(`(min-width: ${width}px)`).matches;
}

export function checkMaxViewport(width) {
  return window.matchMedia(`(max-width: ${width}px)`).matches;
}

export function isMobile() {
  let isMobileDevice = false;

  if (
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  ) {
    isMobileDevice = true;
  }

  return isMobileDevice;
}
